module.exports = __webpack_public_path__ + "img/5.84d8fb63.png";